const helpers = window.BASE_HELPERS || {};
const { Copy } = helpers;

const MODULE = document.querySelectorAll('[data-module="detalhes_do_socio"]');

class DetalhesDoSocio {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            Copy.initCopy();
        });
    }
}

(() => {
    if (MODULE) {
        new DetalhesDoSocio();
    }
})();

export default DetalhesDoSocio;